import * as Constants from "../constants";
import { LiveSessionScheduleForm } from "../models/LiveSessionScheduleForm";

export default function scheduleFormReducer(state, action) {
  switch (action.type) {
    case Constants.SCHEDULE_FORM_TITLE_CHANGE: {
      const newScheduleFormState = new LiveSessionScheduleForm({ previousState: state });
      return newScheduleFormState.updateTitle(action.payload);
    }
    case Constants.SCHEDULE_FORM_DATE_CHANGE: {
      const newScheduleFormState = new LiveSessionScheduleForm({ previousState: state });
      return newScheduleFormState.updateDate(action.payload);
    }
    case Constants.SCHEDULE_FORM_TIME_CHANGE: {
      const newScheduleFormState = new LiveSessionScheduleForm({ previousState: state });
      return newScheduleFormState.updateTime(action.payload);
    }
    case Constants.SCHEDULE_FORM_LANGUAGE_CHANGE: {
      const newScheduleFormState = new LiveSessionScheduleForm({ previousState: state });
      return newScheduleFormState.updateLanguage(action.payload);
    }
    case Constants.SCHEDULE_FORM_DESCRIPTION_CHANGE: {
      const newScheduleFormState = new LiveSessionScheduleForm({ previousState: state });
      return newScheduleFormState.updateDescription(action.payload);
    }
    default:
      return state;
  }
}
